import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, TemplateResult, html } from 'lit';
import componentStyles from './tufts-provider-qualifications.css.lit';
import { classMap } from 'lit/directives/class-map.js';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import { ResizeController } from '../../controllers/resize-controller';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';
import '../tufts-icon/tufts-icon';

@customElement('tufts-provider-qualifications')
export class tuftsProviderQualifications extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles, tuftsHeadingCssLit];
  ngSlot = new SlotNGController(this);
  resizeController: ResizeController = new ResizeController(this);
  @property({ type: Boolean, attribute: 'honor-publication' })
  honorPublication: false;

  render(): TemplateResult {
    const cardWrapperClasses = {
      mobile: this.resizeController.currentBreakpointRange === 0,
    };
    const sizeIcon = this.honorPublication ? '4rem' : '4rem';

    return html`
      <section class=${classMap(cardWrapperClasses)}>
        <div class="content">
          ${this.ngSlot.exist('training-title')
            ? html` <div class="wrapper-icon">
                <tufts-icon
                  name="${this.honorPublication ? 'honor' : 'training'}"
                  library="system"
                  size=${sizeIcon}
                ></tufts-icon>
              </div>`
            : null}
          ${this.ngSlot.conditionalNGSlot('training-title', true, 'md')}
          ${this.ngSlot.conditionalNGSlot('training-content')}
        </div>
        <div class="content">
          ${this.ngSlot.exist('certifications-title')
            ? html`
                <div class="wrapper-icon">
                  <tufts-icon
                    name="${this.honorPublication
                      ? 'publications-national-presentations'
                      : 'certification'}"
                    library="system"
                    size=${sizeIcon}
                  ></tufts-icon>
                </div>
              `
            : null}
          ${this.ngSlot.conditionalNGSlot('certifications-title', true, 'md')}
          ${this.ngSlot.conditionalNGSlot('certifications-content')}
        </div>
      </section>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-provider-qualifications': tuftsProviderQualifications;
  }
}
